<template>

    <div class="blue-point">

        <div class="line top-line" :class="{erase: fisrt}"></div>
        <div class="point"></div>
        <div class="line" :class="{erase: last}"></div>

    </div>


</template>

<script>

export default {
    name: 'blue-point',

    props: {
        fisrt: {
            type: Boolean,
            default: false
        },
        last: {
            type: Boolean,
            default: false
        }
    }
}

</script>

<style lang="scss" scoped>

.blue-point {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;

    .line {
        width: 1px;
        height: 100%;
        flex: 1;
        background-color: $aquamarine;
    }

    .top-line {
        max-height: 4px;
    }

    .erase {
        background-color: transparent;
    }

    .point {
        flex: 2;
        width: 14px;
        max-width: 14px;
        height: 14px;
        max-height: 14px;
        border-radius: 14px;
        background-color: $aquamarine;
        border: solid 3px $white;
    }
}

</style>